import React from 'react'

import Index from './components'
import ParticipantsContextProvider from './context'

const Participants = props => {
    return (
        <ParticipantsContextProvider>
            <Index {...props} />
        </ParticipantsContextProvider>
    )
}

export default Participants
